import axios from "axios"
import normalizeHeaderName from "axios/lib/helpers/normalizeHeaderName"
import utils from "axios/lib/utils"
import {
  BootstrapVue
} from "bootstrap-vue"
import fileDownload from 'js-file-download'
// -- import * as _ from "lodash-es"
import SecureLs from "secure-ls"
import vue from "vue"
import en from "../../public/locales/en.json"
import zhCN from "../../public/locales/zh-CN.json"
import apiPath from "./apiPath"
import * as base_url from "./base_url"
import * as localStorageMgr from "./localStorageMgr"
import * as common_controller from "../../src/controllers/commonController"

vue.use(BootstrapVue)
let vm = new vue()

let _ismsg = false
const ls = new SecureLs({
  encodingType: "aes",
  isCompression: true
})

let lang_json = zhCN
if (localStorageMgr.get(localStorageMgr.data.locale) && localStorageMgr.get(localStorageMgr.data.locale) == "en") {
  lang_json = en
}

// export const JSONBig=JSONbig({
//     alwaysParseAsBig: true,
//     useNativeBigInt: true,
//   })
const setContentTypeIfUnset = function (headers, value) {
  if (
    !utils.isUndefined(headers) &&
    utils.isUndefined(headers["Content-Type"])
  ) {
    headers["Content-Type"] = value
  }
}

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"

axios.defaults.timeout = 5 * 60 * 1000
axios.defaults.transformResponse = [
  function (data) {
    if (typeof data === "string") {
      try {
        data = JSON.parse(data)
      } catch (e) {
        console.log(e)
      }
    }
    return data
  }
]
axios.defaults.transformRequest = [
  function (data, headers) {
    normalizeHeaderName(headers, "Accept")
    normalizeHeaderName(headers, "Content-Type")
    if (
      utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(
        headers,
        "application/x-www-form-urlencoded;charset=utf-8"
      )

      return data.toString()
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, "application/json;charset=utf-8")

      let json = JSON.stringify(data)
      return json
    }

    return data
  }
]
axios.interceptors.request.use(

  config => {
    if (config.url.indexOf("/Pub/") > -1) {
      return config
    }

    var access_token = ls.get("access_token")
    var pub_token = ls.get("pub_guest_token")
    if (access_token && !_.isEmpty(access_token)) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.AccessToken = access_token
    }
    else if (pub_token && !_.isEmpty(pub_token)) {
      config.headers.OpenDataAccessToken = pub_token
      config.headers.AccessToken = pub_token
    }
    var plant_idx = localStorage.getItem("plant_idx")
    if (plant_idx) {
      // 判断是否存在plant_idx，如果存在的话，则每个http header都加上plant_idx
      // config.headers.PlantIdx = JSON.parse(plant_idx);
    }

    //以下是为了兼容v1的代码
    if (config.method === "get") {
      if (config.params === undefined) config.params = {}
      if (config.params.access_token === undefined) {
        if (!_.isEmpty(access_token)) config.params.access_token = access_token
      }
      config.params.plant_idx = plant_idx
    } else if (config.method === "post") {
      if (config.data instanceof FormData) {
        config.data.append("access_token", access_token)
        // config.data.append("plant_idx", plant_idx);
      } else {
        if (config.data === undefined) config.data = {}
        config.data.access_token = access_token
        // config.data.plant_idx = plant_idx;
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
let msg_data = []
let vmMsg = null
axios.interceptors.response.use(
  response => {
    if (response.headers["jwt-isexpired"] != undefined && response.headers["jwt-isexpired"] != "False") {
      window.location.href = "/pages/Login"
    }

    var new_token = response.headers.new_access_token
    if (new_token) {
      ls.set("access_token", new_token)
    }
    if (response.data) {
      if (response.data.Result == null) {
        if (typeof response.data === 'string') {
          let _url = response.data
          response.data = { Result: [], url: _url }
        }
        else
          response.data.Result = []
      }
      if (response.data.HasPrivilege != undefined) {
        if (!response.data.HasPrivilege) {
          let _url = response.config.url
          _url = _url.replace(base_url.base_url, "")
          if (_url == "/data/batch") {
            let _urls = []
            let str = ""
            _.each(response.data.NoPrivilegeCodes, t => {
              if (_.findIndex(msg_data, {
                url: t
              }) < 0) {
                msg_data.push({
                  url: t
                })
              }
            })
          } else {
            if (_.findIndex(msg_data, {
              url: _url
            }) < 0) {
              msg_data.push({
                url: _url
              })
            }
          }
          let _msgDataClone = _.cloneDeep(msg_data)
          if (_msgDataClone.length > 0) {
            if (vmMsg == null) {
              let str = ''
              _.each(_msgDataClone, t => {
                let arr = []
                arr = (t.url).split('/')
                if (arr.length == 4) {
                  str += '<div class="mt-2">' + arr[2] + '-' + arr[3] + '</div>'
                }
                if (arr.length == 3) {
                  str += '<div class="mt-2">' + arr[1] + '-' + arr[2] + '</div>'
                }

              })

              vmMsg = vm.$message({
                dangerouslyUseHTMLString: true,
                message: '<div class="ml-auto"><strong style="text-align:center">' + lang_json.notify["not_privileges_content_admin"] + '</strong></div>' +
                  str,
                type: 'error',
                showClose: true,
                duration: 0,
                customClass: 'zZindex',
                onClose: function () {
                  _ismsg = false
                  msg_data = []
                  vmMsg = null
                }
              })
            } else {
              let str = ''
              _.each(_msgDataClone, t => {
                let arr = []
                arr = (t.url).split('/')
                if (arr.length == 4) {
                  str += '<div class="mt-2">' + arr[2] + '-' + arr[3] + '</div>'
                }
                if (arr.length == 3) {
                  str += '<div class="mt-2">' + arr[1] + '-' + arr[2] + '</div>'
                }

              })
              vmMsg.message =
                '<div class="ml-auto"><strong style="text-align:center">' + lang_json.notify["not_privileges_content_admin"] + '</strong></div>' +
                str
            }
          }
          _ismsg = true
        }
      }
      let _msg = ""
      if (response.data.status) {
        _msg = "错误代码：" + response.data.status + "，" + response.data.title
      }
      if (_msg != "") {
        if (!_ismsg) {
          vm.$message({
            message: _msg,
            type: "error",
            duration: 0,
            showClose: true,
            onClose: function () {
              _ismsg = false
            }
          })
          _ismsg = true
        }
      }
    }
    return response
  },
  error => {
    if (error.response) {
      var new_token = error.response.headers.new_access_token
      if (new_token) {
        ls.set("access_token", new_token)
      }

      if (error.response.status === 401) {
        ls.remove("access_token")
        if (error.response && error.response.config && error.response.config.url && error.response.config.url.indexOf("/upload/") > -1) { }
        else window.location.href = "/pages/Login"
      }

      // switch (error.response.status) {
      //   case 401:
      //     ls.remove("access_token")
      //     // 返回 401 清除token信息并跳转到登录页面


      //     // this.$message({
      //     //   showClose: true,
      //     //   message: '没有相应权限!请联系管理员.',
      //     //   type: 'error',
      //     //   duration:0
      //     // });
      //     break
      //   default:
      //     console.log(error.response)
      //     if (error.response && error.response.config && error.response.config.url && error.response.config.url.indexOf("/upload/") > -1) { }
      //     else window.location.href = "/pages/Login"
      //     break
      // }
      return Promise.reject(error.response.data) // 返回接口返回的错误信息
    }
  }
)

export const request = function (query_setting) {
  let req = function (url, params, method) {
    if (method === "post") {
      if (params instanceof FormData) {
        return axios.post(url, params, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
      } else {
        return axios.post(url, params)
      }
    } else {
      if (_.isNull(params)) {
        return axios.get(url)
      } else {
        return axios.get(url, {
          params: params
        })
      }
    }
  }
  return req(query_setting.url, query_setting.parameters, query_setting.method)
}

export const query_batch = async function (batch_actions, log_data = null) {
  if (log_data == null) {
    log_data = {
      category: 'GENERAL_BATCH',
      content_type: '',
      info: JSON.stringify(batch_actions.actions.map(o => { return o.code })),
      //data: JSON.stringify(batch_actions),
      idx: ''
    }
  }
  if (!log_data.data) {
    log_data.data = JSON.stringify(batch_actions)
  }
  await common_controller.methods.saveLogClient(log_data, 1)
  const result = await axios.post(base_url.base_url + "/data/batch", batch_actions)
  log_data.data = ''
  await common_controller.methods.saveLogClient(log_data, 2)
  return result
}

export const query_async = async function (query_settings, callback) {
  //权限验证
  let req = function (url, params, method) {
    if (method === "post") {
      if (params instanceof FormData) {
        return new Promise((resolve, reject) => {
          axios
            .post(url, params, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        })
      } else {
        return new Promise((resolve, reject) => {
          axios
            .post(url, params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        })
      }
    } else {
      return new Promise((resolve, reject) => {
        let _url = url
        if (_.isNull(params)) {
          axios
            .get(_url)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        } else {
          axios
            .get(url, {
              params: params
            })
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    }
  }
  if (!(query_settings instanceof Array)) {
    query_settings = [query_settings]
  }
  let results = []
  for (let i = 0; i < query_settings.length; i++) {
    let query_setting = query_settings[i]
    let code = query_setting.code ? query_setting.code : "_" + i
    let content_type = query_setting.content_type
    let ref = query_setting.ref ? query_setting.ref : null

    try {
      let invoke_result = {
        code,
        content_type,
        result: await req(
          query_setting.url,
          query_setting.parameters,
          query_setting.method
        ),
        ref
      }
      if (callback) {
        results.push(invoke_result)
        if (!callback(invoke_result)) {
          //this is a chance to cancel next querys, eg. return false when check valid remain
          break
        }
      } else {
        results.push(invoke_result)
      }
    } catch (e) {
      results.push({
        code: code,
        error: e
      })
    }
  }

  return results
}

export const query_all_async = async function (query_settings) {
  //this is no chance to cancel querys
  let requests = []
  if (!(query_settings instanceof Array)) {
    query_settings = [query_settings]
  }
  for (let i = 0; i < query_settings.length; i++) {
    let query_setting = query_settings[i]
    requests.push(request(query_setting))
  }
  let r = await Promise.allSettled(requests)
  let results = []
  for (let i = 0; i < query_settings.length; i++) {
    let query_setting = query_settings[i]
    let code = query_setting.code ? query_setting.code : "_" + i
    let content_type = query_setting.content_type
    let ref = query_setting.ref ? query_setting.ref : null
    results.push({
      code,
      content_type,
      result: r[i].value,
      ref
    })
  }

  return results
}

export const downloadFile = async function (p) {
  await axios.get(p.url, {
    responseType: 'blob',
  }).then(res => {
    fileDownload(res.data, p.fileName)
  }).catch(err => {
    fileDownload(err, p.fileName)
  })
}
export const pub_url = function (action, idx, code) {
  let path = apiPath.pub.get_pub_data
  if (action == "save") path = apiPath.pub.save_pub_data
  let token = ls.get(localStorageMgr.data.pub_guest_token)
  return path + idx + "/" + code + "?pub_token=" + token
}

